import api from "./client";

export const getSiteOverview = async (siteId: number | string, period: string) => {
  const res = await api.get(`/analytics/overview/site/${siteId}`, {
    params: { period },
  });
  return res.data;
};

export const getTransformerOverview = async (transformerId: number | string, period: string, arrayId?: number | string) => {
  const res = await api.get(`/analytics/overview/transformer/${transformerId}`, {
    params: { period, array_id: arrayId },
  });
  return res.data;
};

export const runAnalytics = async (siteId: number | string) => {
  const res = await api.post(`/analytics/run/${siteId}`);
  return res.data;
};

export const reprocessAnalytics = async (siteId: number | string, period: string) => {
  const res = await api.post(`/analytics/reprocess/${siteId}`, null, { params: { period } });
  return res.data;
};
